import React from 'react';
import Dashboard from '../Dashboard';
import ThanksAppMain from './ThanksAppMain'

export default function ThanksApp() {
    return (
        <div>
            <Dashboard cmp={<ThanksAppMain />} />
        </div>
    )
}